import React, { useContext, useState } from "react";
import { EditorContext, ModalServiceContext, PluginsEventsContext } from "./../../ricos-context";
import { SETTINGS_TAB } from "../constants";
import { SettingsModalContent } from "./SettingsModalContent";
const ButtonSettingsModal = ({ nodeId, settings, type, modalId, activeTab: tab }) => {
  const modalService = useContext(ModalServiceContext) || {};
  const { getEditorCommands } = useContext(EditorContext);
  const pluginsEvents = useContext(PluginsEventsContext);
  const [initialData] = useState(
    () => getEditorCommands().getBlockComponentData(nodeId)
  );
  const [componentData, setComponentData] = useState(
    () => getEditorCommands().getBlockComponentData(nodeId)
  );
  const [activeTab, setActiveTab] = useState(tab ?? SETTINGS_TAB.SETTINGS);
  const handleOnChange = (data) => {
    setTimeout(() => {
      getEditorCommands().setBlock(nodeId, type, {
        ...componentData,
        ...data,
        id: nodeId
      });
    }, 0);
    setComponentData({ ...componentData, ...data });
  };
  const closeModal = () => {
    modalService.closeModal(modalId);
  };
  const handleOnSave = () => {
    closeModal();
  };
  const handleOnCancel = () => {
    handleOnChange(initialData);
    closeModal();
  };
  const helpers = {
    onPluginAction: (_, { plugin_id, ...params }) => pluginsEvents.publishPluginLinkable({ pluginId: plugin_id, nodeId, ...params })
  };
  return componentData ? /* @__PURE__ */ React.createElement(
    SettingsModalContent,
    {
      buttonData: componentData,
      helpers,
      config: settings,
      onCloseRequested: closeModal,
      onChange: handleOnChange,
      onSave: handleOnSave,
      onCancel: handleOnCancel,
      nodeId,
      activeTab,
      onTabChange: setActiveTab
    }
  ) : null;
};
var SettingsModal_default = ButtonSettingsModal;
export {
  SettingsModal_default as default
};
//# sourceMappingURL=SettingsModal.js.map
